// Locator pins
jQuery( document ).ready(function($) {
  if ($('.reservation').length){
    // $('.reservation_date input_3_9').datepicker();
    var userlogin = $('.reservation').find( '.reservation_userlogin' ).html();
    $('.reservation_nom input').val(userlogin);
    var useremail = $('.reservation').find( '.reservation_useremail' ).html();
    $('.reservation_email input').val(useremail);
    $( '.reservation_pin' ).hover(
      function() {
        $(this).next($( '.reservation_name' )).css('visibility', 'visible');
        $('.reservation_pin').css('z-index', 'unset');
        $(this).css('z-index', '2');
        $(this).parent().css('z-index', '2');
      }, function() {
        $(this).next($( '.reservation_name' )).css('visibility', 'hidden');
        $('.reservation_pin').css('z-index', '3');
        $(this).parent().css('z-index', 'unset');
      }
    );
    $( '.reservation_pin' ).click(function() {
      var nameloc = $( this ).parent().find( '.reservation_name' ).html();
      $('.reservation_lieu input').val(nameloc);
      var emailloc = $( this ).parent().find( '.reservation_email' ).html();
      $('.reservation_ecole input').val(emailloc);
      var pin = $(this).data('pin');
      $( '.reservation_infos' ).hide();
      $('.reservation_infos').each(function(i, obj) {
        if ( $(this).data('infos') == pin ) {
          $(this).show();
        }
      });
    });
    $('.reservation_univers select').on('change', function() {
      var pin = $(this).val();
      $( '.reservation_infos' ).hide();
      $( '.reservation_pointer' ).hide();
      $('.reservation_lieu input').val('');
      $('.reservation_ecole input').val('');
      $('.reservation_pointer').each(function(i, obj) {
        var alluniv = $(this).data('univers');
        var arruniv = alluniv.split(",");
        for (let i = 0; i < arruniv.length; ++i) {
          if ( arruniv[i] == pin ) {
            $(this).show();
          }
        }
      });
    });
  }
  
});
// End
